<template>
    <div
        class="a-select"
    >
        Typ dokumentu:
        <select
            class="a-select__select"
            @change="onChangeHandler($event)"
            :value="documentTypeId"
        >
            <option value="-1">--- wybierz ---</option>
            <option
                v-for="(type, key) in documentTypes"
                v-bind:key="`documentType${key}`"
                :value="type.id"
            >{{ type.name }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        documentTypeId: {
            type: Number,
            required: true
        }
    },
    computed: {
        documentTypes() {
            return this.$store.getters.documentTypes
        }
    },
    methods: {
        onChangeHandler(event) {
            this.$emit('document-type-change', event.target.value)
        }
    }
}
</script>
